<div class="table-responsive" *ngIf="tableInfo != null">
    <div class="mb-4 label" *ngIf="tableInfo.label">
        <span>{{ tableInfo.label | translate }}</span>
    </div>
    <div class="text-dark text-center my-2" *ngIf="tableInfo.items.length == 0">
        {{ "TABLE_LIST_NO_ELEMENTS_LABEL" | translate }}
    </div>
    <table *ngIf="tableInfo.items.length > 0" class="table table-hover">
        <thead>
            <tr>
                <th
                    scope="col"
                    class="border-0"
                    *ngFor="let key of objectKeys(tableInfo.headers)"
                    (click)="onHeaderClick(key)"
                    [ngClass]="{
                        'sort-enabled': tableInfo.headers[key].sortEnabled,
                        'selected-header': tableInfo.headers[key].selected,
                        title: key === 'title'
                    }"
                >
                    {{ tableInfo.headers[key].text | translate }}
                    <i class="fa fa-sort-up" [hidden]="!isSortAscEnabled(key)"></i>
                    <i class="fa fa-sort-down" [hidden]="!isSortDescEnabled(key)"></i>
                </th>
            </tr>
        </thead>
        <tbody>
            <tr
                *ngFor="let item of tableInfo.items; let i = index"
                [ngClass]="{
                    'button-over-even': i === onButtonOverIndex
                }"
            >
                <td
                    class="border-top-0"
                    *ngFor="let key of objectKeys(item)"
                    [ngClass]="{
                        comment: key === 'comment',
                        title: key === 'title',
                        'item-column-disabled': tableInfo.disableItems ? tableInfo.disableItems[i] === true : true
                    }"
                >
                    {{ item[key] }}
                    <i *ngIf="key === 'ppm'" class="mi-price"></i>
                </td>
                <td class="border-top-0" *ngIf="this.tableInfo.buttons">
                    <ng-container *ngFor="let button of this.tableInfo.buttons">
                        <button
                            class="btn px-1 py-1 rounded m-1"
                            (mouseover)="onButtonOver(i)"
                            (mouseout)="onButtonLoseFocus()"
                            [ngStyle]="{ 'background-color': button.color }"
                            (click)="button.callback(i)"
                        >
                            <i class="text-white {{ button.icon }}"></i>
                        </button>
                    </ng-container>
                </td>
            </tr>
            <ng-container *ngIf="tableEmptyInfo">
                <tr *ngFor="let item of tableEmptyInfo.items; let last = last">
                    <td class="border-top-0 p-4" *ngFor="let key of item" [ngClass]="{ rounded: last }"></td>
                    <td class="border-top-0 p-4" *ngIf="tableInfo.buttons !== null"></td>
                </tr>
            </ng-container>
        </tbody>
    </table>
    <button
        *ngIf="tableInfo.optionalButton"
        class="btn px-5 py-1 my-2 float-right rounded"
        [ngStyle]="{ 'background-color': tableInfo.optionalButton.color }"
        (click)="tableInfo.optionalButton.callback(tableInfo)"
    >
        <span [ngStyle]="{ color: tableInfo.optionalButton.fontColor }">{{
            tableInfo.optionalButton.label | translate
        }}</span>
    </button>
</div>
